// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"76216964","788":"6546ca41"}[chunkId] + ".chunk.js";
};